import { render, staticRenderFns } from "./KpiRow.vue?vue&type=template&id=5b4106ee&scoped=true&"
import script from "./KpiRow.vue?vue&type=script&lang=js&"
export * from "./KpiRow.vue?vue&type=script&lang=js&"
import style0 from "./KpiRow.vue?vue&type=style&index=0&id=5b4106ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4106ee",
  null
  
)

export default component.exports